// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `angular-cli.json`.

import { version } from './version';

export const environment = {
  production: true,
  appVersionAddon: '',
  webappName: 'Straatbeeld Online Behandelaar',
  api_endpoint: 'https://api.straatbeeld.online/',
  pusher: {
    broadcaster: 'pusher',
    key: '97e11b02bfecf322e6a3',
    cluster: 'eu',
    forceTLS: true,
  },
  pusher_beams_client_id: '7d64a0d2-77d6-4b59-a7ff-7c41cf3c7319',
  sentry: {
    dsn: 'https://b2cdd327256879a4c31c02b9cc279463@o4507735602298880.ingest.de.sentry.io/4508745347498064',
    version: version
  }
};
